import { ReactNode } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { theme } from 'shared/theme/theme';

// eslint-disable-next-line react/display-name
export const ThemeProvider = (component: () => ReactNode) => () => (
  <MuiThemeProvider theme={theme}>{component()}</MuiThemeProvider>
);
